import {Injectable} from '@angular/core';
import {Storage} from "@ionic/storage-angular";

@Injectable({
  providedIn: 'root'
})
export class StorageService {
  private _storage: Storage | null = null;

  constructor(private storage: Storage) {
  }

  async init() {
    // If using, define drivers here: await this.storage.defineDriver(/*...*/);
    this._storage = await this.storage.create();
  }

  // Create and expose methods that users of this service can
  // call, for example:
  public async set(key: string, value: any) {
    if (this._storage == null) {
      await this.init();
    }
    await this._storage?.set(key, value);
  }

  public async get(key: string): Promise<any> {
    if (this._storage == null) {
      await this.init();
    }
    return this._storage?.get(key);
  }

  public async remove(key: string): Promise<any> {
    if (this._storage == null) {
      await this.init();
    }
    return this._storage?.remove(key);
  }

  public async removeAll(): Promise<any> {
    if (this._storage == null) {
      await this.init();
    }
    return this._storage?.clear();
  }

}
